'use strict';

angular.module('studies', [
    'event',
    'sharecrf-sdk',
    'sharecrf-url',
    'portal.i18n',
]);
